module.exports = __webpack_public_path__ + "static/media/roboto-light-webfont.ccb70e60.woff";